module.exports = __webpack_public_path__ + "static/4p-3-d43b08d36e8de08278e5fa2280e4aa2b.jpeg";